function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgValidator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 17",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(1.960784%,0.392157%,0%)",
      fillOpacity: 1
    },
    d: "M 14.601562 12.035156 C 14.6875 11.765625 14.738281 11.484375 14.738281 11.1875 L 14.738281 10.851562 L 14.757812 10.851562 C 15.464844 10.851562 16.039062 10.292969 16.039062 9.609375 C 16.039062 9.4375 16.003906 9.269531 15.929688 9.109375 L 15.929688 9.105469 L 15.925781 9.097656 L 14.949219 7.023438 L 16.613281 7.28125 L 16.765625 6.367188 L 15.421875 6.160156 C 15.421875 6.15625 15.421875 6.152344 15.421875 6.148438 L 13.546875 2.125 C 13.484375 1.996094 13.367188 1.898438 13.226562 1.863281 L 5.679688 0.015625 C 5.472656 -0.0351562 5.253906 0.0507812 5.148438 0.234375 L 2.800781 4.203125 L 1.507812 4.003906 L 1.359375 4.917969 L 3.28125 5.214844 C 3.136719 5.707031 3.058594 6.226562 3.058594 6.765625 C 3.058594 7.769531 3.328125 8.726562 3.820312 9.566406 L 1.980469 9.148438 L 3.035156 12.578125 C 1.324219 13.21875 0.0898438 14.792969 0 16.65625 L 15.753906 16.65625 L 15.171875 14.402344 L 16.625 12.496094 Z M 4.011719 6.765625 C 4.011719 6.277344 4.089844 5.804688 4.230469 5.359375 L 13.820312 6.847656 L 15.058594 9.480469 L 15.054688 9.480469 C 15.074219 9.519531 15.085938 9.5625 15.085938 9.609375 C 15.085938 9.785156 14.9375 9.925781 14.757812 9.925781 L 13.78125 9.925781 L 13.78125 11.1875 C 13.78125 11.410156 13.742188 11.621094 13.667969 11.820312 L 5.234375 9.890625 C 4.476562 9.058594 4.011719 7.964844 4.011719 6.765625 Z M 4.011719 6.765625 ",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidator);
export default __webpack_public_path__ + "static/media/Validator.e260d61fed0e53b371fb3af468115e03.svg";
export { ForwardRef as ReactComponent };